export const apiEndpoints = {
  updatePassUrl: "/users/",
  forgetPassUrl: "/sendEmail",
  registerApiUrl: "/api/register",
  loginApiUrl: "/api/login",
  getAllBlogs: "/blogs",
  createBlogApiUrl: "/blogs",
  saveBlogsApiUrl: "/blogs/savedblogs/",
  profileUpdateApiUrl: "/profile",
  publishBlogApiUrl: "/publishBlog",
  likesApiUrl: "/likes",
  saveBLogApiUrl: "/saveblog",
  getSavedBlogsApiUrl: "/usersaved",
  profileCheckingApiUrl: "/profile/check",
  commentsApiUrl: "/comments",
  uploadThumbnailUrl: "/post/blogthumb",
  deleteUploadedImageUrl: "/post/blogthumb",
  deleteBlogUrl: "/blogs",
  postWinnerUrl: "/api/winners",
  getWinnerUrl: "/api/winners",
  blogSummary: "/summarize",
  profileImageUrl: "/upload/profile-image",
  generateUserBioUrl: "/generateBio",
  getAuthorUrl: "/author",
  getAuthorBlogsUrl: "/blogs/author",
  likeCommentsUrl: "/comments/like",
  commentReplyUrl: "/comments/reply",
  publishBlogToWebUrl: "/api/publishblogs/aapmor",
  getTrendingBLogsUrl: "/top-liked-blogs",
  getNotificationsUrl: "/notifications",
  refreshToken: "/auth/refresh-token",
  filterBlogsApiUrl: "/blogs/filter",
  getActivityUrl: "/api/activity",
  storiesUrl: "/stories",
  enhanceStoryUrl: "/stories/enhance",
  blogCompanionUrl: "/blogs/companion",
  profileDashboardUrl: "/profile/dashboard",
  blogDraftUrl: "/profile/draft-blog",
  aiGenerateProfileBioUrl: "/profile/ai/generate-bio",
  aiImproveProfileBioUrl: "/profile/ai/improve-bio",
  aiProfileVoiceUrl: "/profile/ai/voice",
  aiProfileIdeasUrl: "/profile/ai/ideas",
  aiProfileInsightsUrl: "/profile/ai/insights",
  analyticsEventsUrl: "/analytics/events",
  analyticsSummaryUrl: "/analytics/summary",
};
